var elem = document.querySelector('.bundle_slider');
if(elem){
  var flkty = new Flickity(elem, {
    // options
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    wrapAround: false,
    draggable: true,
    dragThreshold: 8,
    watchCSS: true,
    groupCells: true,
    arrowShape: 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z'
  });  
}


var elemsTag = document.querySelectorAll('.tag_bundle_slider');
elemsTag.forEach(function (elem) {
  var flktyTag = new Flickity(elem, {
    // options
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    wrapAround: false,
    draggable: true,
    groupCells: false,
    arrowShape: 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z',
  });
});

function observeAnnouncementBarHeight() {
  const appBarSelector = '#cb-shipping-bar, #ymTopbar';
  let observerInitialized = false;

  const setAnnouncementVars = (heightPx, isSticky) => {
    document.documentElement.style.setProperty('--announcement-bar-height', heightPx);
    document.documentElement.style.setProperty('--announcement-bar-is-sticky', isSticky ? '1' : '0');
    // Keep the custom variable for compatibility if used elsewhere
    document.documentElement.style.setProperty('--top-bar-height', heightPx);
  };

  const isEffectivelyVisible = (el) => {
    if (!el) return false;
    const cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') === 0) return false;
    const rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    return rect.bottom > 0 && rect.top < window.innerHeight;
  };

  const isPinnedToTop = (el) => {
    // We only want the header to offset when the app bar is actually pinned at the top.
    const cs = window.getComputedStyle(el);
    const pos = cs.position;
    if (pos !== 'fixed' && pos !== 'sticky') return false;

    const top = parseFloat(cs.top || '0') || 0;
    // Most apps pin at top: 0; allow tiny sub-pixel variance.
    if (Math.abs(top) > 2) return false;

    const rect = el.getBoundingClientRect();
    return Math.abs(rect.top) <= 2;
  };

  const updateHeight = () => {
    let totalHeight = 0;
    let isSticky = false;
    const elements = document.querySelectorAll(appBarSelector);
    
    elements.forEach(element => {
      if (isEffectivelyVisible(element) && isPinnedToTop(element)) {
        totalHeight += element.offsetHeight || 0;
        isSticky = true;
      }
    });

    if (!isSticky) {
      setAnnouncementVars('0px', false);
      return;
    }

    setAnnouncementVars(totalHeight + 'px', true);
  };

  const startObserving = (element) => {
    if (!observerInitialized) {
      // Handle window resize as a backup/sync measure
      window.addEventListener('resize', updateHeight);
      observerInitialized = true;
    }
    
    updateHeight();
    
    // Use ResizeObserver to catch any layout changes within the bar itself
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(updateHeight);
      resizeObserver.observe(element);
    }
  };

  const checkExistingAndObserve = () => {
    const elements = document.querySelectorAll(appBarSelector);
    elements.forEach(el => startObserving(el));
  };

  // Check if already in DOM
  checkExistingAndObserve();

  // Wait for the app to inject it
  const mutationObserver = new MutationObserver((mutations, obs) => {
    const elements = document.querySelectorAll(appBarSelector);
    if (elements.length > 0) {
      elements.forEach(el => {
        // Only observe if not already observing (we can check if it has a specific attribute, but startObserving handles the global resize listener. ResizeObserver needs to be per element.)
        if (!el.dataset.heightObserved) {
          el.dataset.heightObserved = "true";
          startObserving(el);
        }
      });
    }
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Initialize the observer
observeAnnouncementBarHeight();



//Mobile open size SWATCH COLLECTION PAGE
window.sizeWrapper = function sizeWrapper(){
  document.querySelectorAll('.js-size-button').forEach((item) =>{
    item.addEventListener('click', function(Ele){    
        let getProductId = Ele.currentTarget.getAttribute('data-product-id');		
          document.querySelectorAll('.js-product-size-wrapper').forEach(function(el){
              el.classList.remove('is-active');
          });
  
        if(Ele.currentTarget.closest('product-list')){
            Ele.currentTarget.closest('product-list').querySelector(`.js-product-size-wrapper[data-product-id="${getProductId}"]`).classList.add('is-active');
            Ele.currentTarget.closest('product-list').querySelector(`.js-product-size-wrapper[data-product-id="${getProductId}"]`).classList.remove('hidden');
            document.body.classList.add('size_chart_open');                 
        }
      
        if(Ele.currentTarget.closest('.bundle_main')){
            Ele.currentTarget.closest('.bundle_main').querySelector(`.js-product-size-wrapper[data-product-id="${getProductId}"]`).classList.add('is-active');
            Ele.currentTarget.closest('.bundle_main').querySelector(`.js-product-size-wrapper[data-product-id="${getProductId}"]`).classList.remove('hidden');
            document.body.classList.add('size_chart_open');                 
        }	
      
    })
  })
}
window.sizeWrapper();

  
  let sizeWrapProduct = document.querySelector('.js-product-size-wrapper');
  document.body.addEventListener('click', (event) => {
      if(event.target.closest('.js-size-button')) {
          return;
      }
      if (event.currentTarget.classList.contains('size_chart_open')) {
          event.currentTarget.classList.remove('size_chart_open');
              document.querySelectorAll('.js-product-size-wrapper').forEach(function (Ele) {
                  if (Ele.classList.contains('is-active')) {
                      Ele.classList.remove('is-active');
                      Ele.classList.add('hidden');
                  }
              });
      }
  });

  class ProductWrapper extends HTMLElement {
    connectedCallback() {
      this.attachEventListeners();
      this.changproductPrice();

    }
    attachEventListeners() {
      let getCustomSwatchId = this.querySelectorAll(".customSwatch");
      let getNewhtmlReplase = this.querySelector(".js-replase-html");
      let jsonData = JSON.parse(getNewhtmlReplase.innerHTML);
  
      if (getCustomSwatchId) {
        getCustomSwatchId.forEach((item) => {
          item.addEventListener('click', (e) => {
            let customSwatchId = e.currentTarget.getAttribute('productData');
            let productCardElement = this.querySelector("product-card");  
            if (customSwatchId in jsonData) {
              if (productCardElement) {
                // Update the product-card HTML
                productCardElement.outerHTML = jsonData[customSwatchId];
                let card = this.querySelector('product-card[reveal-on-scroll="true"]');
                 if (card) {
                      card.style.opacity = 1;
                    }
    
                // Reattach event listeners to the new elements
                this.attachEventListeners();
                window.sizeWrapper();
           
              } else {
                console.error('product-card element not found');
              }
            } else {
              console.error('Invalid customSwatchId:', customSwatchId);
            }
          });
        });
      } else {
        console.error('No customSwatch elements found');
      }
    }

    
    changproductPrice() {
      this.querySelectorAll(".product-card__media").forEach((item, index) => {
        const itemUrl = item.getAttribute("href");
        let itemUrls = itemUrl.split("?")[0]
        const productCard = item.closest(".product-card");
    
        const priceContainer =
          productCard.querySelector('.custombundle_Price') ||
          productCard.querySelector('price-list');
    
          fetch(`${window.location.origin}${itemUrls}?section_id=bundle-product-price`)
            .then(response => {
              if (!response.ok) throw new Error('Network response was not ok');
              return response.text();
            })
            .then(responseText => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(responseText, 'text/html');
    
              const priceElement =
                doc.querySelector('.custombundle_Price') ||
                doc.querySelector('price-list');
    
              // console.log('Fetched price element:', priceElement);
    
              if (priceElement && priceContainer) {
                priceContainer.outerHTML = priceElement.outerHTML;
              } else if (priceContainer) {
                priceContainer.outerHTML = ''; 
              } else {
                console.warn('No price container found to replace or remove.');
              }
            })
            .catch(error => {
              console.error('Fetch error for:', itemUrl, error);
              if (priceContainer) {
                priceContainer.outerHTML = '';
              }
            });
        
      });
    }
  }
  
  customElements.define("product-wrapper", ProductWrapper);

  class BundleTagItem extends HTMLElement {
    constructor() {
      super();
      this.swatchHtmlContainer = null;
    }
  
    connectedCallback() {
      console.log("Connected to the DOM");
      this.swatchElements = this.querySelectorAll(".color_swatch_product_list .tooltip_old_design");
      this.fetchAndStoreSwatchHtmlWithTimeout();
      this.attachClickEvent();
    }
  
    async fetchAndStoreSwatchHtmlWithTimeout(){
      let swatchProducts = {};
      for (let index = 0; index < this.swatchElements.length; index++) {
        let colorSwatch = this.swatchElements[index];
        const swatchUrl = colorSwatch.href;
        const swatchId = colorSwatch.dataset.swatchid;
        console.log(colorSwatch,swatchId,swatchUrl)
        let fetchData = await fetch(`${swatchUrl}?view=ajax-bundle-product`);
        let fetchResponce = await fetchData.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(fetchResponce, "text/html");
        const bundleTagMain = doc.querySelector("bundle-tag-item .bundle_tag_item");
        swatchProducts[swatchId] = bundleTagMain.outerHTML;
      }
      let newElement = document.createElement('script');
      newElement.setAttribute('type','application/json');
      newElement.classList.add('js-color-products-html');
      newElement.innerHTML = JSON.stringify(swatchProducts);
      this.insertAdjacentElement('beforeend',newElement);
    }
  
    attachClickEvent(newSwatchElements = null) {
      let elements = newSwatchElements || this.swatchElements;
      elements.forEach((element) => {
        element.addEventListener("click", this.handleSwatchClick.bind(this, element));
      });
    }
  
    handleSwatchClick(element, event) {
      event.preventDefault();
      event.stopPropagation();

      let productJson = JSON.parse(this.querySelector('.js-color-products-html').innerHTML);
      const swatchId = element.dataset.swatchid;
      const swatchDiv = productJson[swatchId];
  
      if (swatchDiv) {
        this.replaceContent(swatchDiv);
      } else {
        console.warn(`No swatch HTML found for swatch ID: ${swatchId}`);
      }
  
      this.reattachClickEvent();
    }
  
    reattachClickEvent() {
      const newSwatchElements = this.querySelectorAll(".tooltip_old_design");
      this.attachClickEvent(newSwatchElements);
      this.initializeSliders(); // Reinitialize sliders after content replacement
    }
  
    replaceContent(newContent) {
      this.querySelector('.bundle_tag_item').outerHTML = newContent; // Replace content with new swatch HTML
      console.log("Content replaced with new swatch HTML.");
      this.initializeSliders(); // Initialize sliders after content replacement
    }
  
    initializeSliders() {
      // Ensure Flickity is properly destroyed before reinitializing
      const existingSliders = document.querySelectorAll('.flickity-enabled');
      existingSliders.forEach(slider => {
        const flickityInstance = Flickity.data(slider);
        if (flickityInstance) {
          flickityInstance.destroy(); // Destroy previous Flickity instances
          console.log("Destroyed previous Flickity instance.");
        }
      });
  
      // Initialize Flickity on the '.bundle_slider' element
      const bundleSlider = document.querySelector('.bundle_slider');
      if (bundleSlider) {
        try {
          new Flickity(bundleSlider, {
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            wrapAround: false,
            draggable: true,
            dragThreshold: 8,
            watchCSS: true,
            groupCells: true,
            arrowShape: 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z'
          });
          console.log("Flickity slider initialized for .bundle_slider.");
        } catch (error) {
          console.error("Error initializing Flickity slider for .bundle_slider:", error);
        }
      }
  
      // Initialize Flickity on '.tag_bundle_slider' elements
      const tagSliders = document.querySelectorAll('.tag_bundle_slider');
      tagSliders.forEach((tagSlider) => {
        try {
          new Flickity(tagSlider, {
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            wrapAround: false,
            draggable: true,
            groupCells: false,
            arrowShape: 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z'
          });
          console.log("Flickity tag slider initialized.");
        } catch (error) {
          console.error("Error initializing Flickity tag slider:", error);
        }
      });
    }
  }
  
  customElements.define("bundle-tag-item", BundleTagItem);

// "&phcursor=" Meta Tag Add Remove Script
window.metaTagUpdate = function metaTagUpdate(isPageLoaded){
  if (isPageLoaded) {
    sessionStorage.removeItem('noindex_exist');
    sessionStorage.removeItem('noindex_added');
  }
  let metaTagMain = document.querySelector('meta[name="robots"][content="noindex"]');
  let alreadyExist = sessionStorage.getItem('noindex_exist');
  let manualAdded = sessionStorage.getItem('noindex_added');
  let url = new URL(window.location.href);
  if (metaTagMain && alreadyExist != 'true' && manualAdded != 'true'){
    sessionStorage.setItem('noindex_exist', 'true');
    return
  }
  if (alreadyExist == 'true') {
    return
  }
  else {
    if(url.href.includes('phcursor')){
      if (manualAdded == 'true') return;
      document.head.insertAdjacentHTML(
        "afterbegin",
        `<meta name="robots" content="noindex">`
      );
      sessionStorage.setItem('noindex_added', 'true');
    } else {
      if (manualAdded == 'true') {
        sessionStorage.removeItem('noindex_added');
        metaTagMain.remove();
      }
    }
  }
}

if(window.location.href.includes('phcursor')){
  window.metaTagUpdate(true);
}
  
{
  let featuredBlockCheck = document.querySelector('.js-block-card');
  let desktopLayoutSwitch = document.querySelector('.js-desktop-layout-switch');
  let mobileLayoutSwitch = document.querySelector('.js-mobile-layout-switch');

  window.updateLayoutButtonsFor = function (device) {

    let sectionEl = document.querySelector('product-list');

    if (!sectionEl) return;
    
    let styles  = getComputedStyle(sectionEl);
    let compact = styles.getPropertyValue('--collection-items-per-row-compact').trim();
    let medium  = styles.getPropertyValue('--collection-items-per-row-medium').trim();
    let large   = styles.getPropertyValue('--collection-items-per-row-large').trim();
    let switchElement = document.querySelector(
      `collection-layout-switch[device="${device}"]`
    );
    
    if (!switchElement) return;
    
    switchElement.querySelectorAll('.js-layout-switch-button').forEach(btn => {
      let size = btn.value;
      let count = size === 'compact'
        ? compact
        : size === 'medium'
        ? medium
        : size === 'large'
        ? large
        : null;

      if (count) {
        btn.dataset.columnCount = count;
      }
    });
  }

  if (featuredBlockCheck) {
    window.addEventListener('resize', () => {
      desktopLayoutSwitch = document.querySelector('.js-desktop-layout-switch');
      mobileLayoutSwitch = document.querySelector('.js-mobile-layout-switch');
      if (window.matchMedia("(max-width: 699px)").matches) {
        updateLayoutButtonsFor('mobile');
        if (mobileLayoutSwitch) {  
          let mobileSwitchElement = mobileLayoutSwitch.querySelector(`.is-active`);
          window.updateFillersOnLayoutSwitch(mobileSwitchElement, mobileLayoutSwitch);
        }
      } else {
        updateLayoutButtonsFor('desktop');
        if (desktopLayoutSwitch) {
          let desktopSwitchElement = desktopLayoutSwitch.querySelector(`.is-active`);
          window.updateFillersOnLayoutSwitch(desktopSwitchElement, desktopLayoutSwitch);
        }
      }
    });
    
    if (window.matchMedia("(max-width: 699px)").matches) {
      updateLayoutButtonsFor('mobile');
      if (mobileLayoutSwitch) {
        let mobileSwitchElement = mobileLayoutSwitch.querySelector(`.is-active`);
        window.updateFillersOnLayoutSwitch(mobileSwitchElement, mobileLayoutSwitch);
      }
    } else {
      updateLayoutButtonsFor('desktop');
      if (desktopLayoutSwitch) {
        let desktopSwitchElement = desktopLayoutSwitch.querySelector(`.is-active`);
        window.updateFillersOnLayoutSwitch(desktopSwitchElement, desktopLayoutSwitch);
      }
    }
  }
}

/**
 * Infinite Scroll implementation for Collection Page
 */
function initInfiniteScroll() {
  const scrollContainer = document.querySelector('.collection__main.js-infinite-scroll-container');
  const sentinel = document.getElementById('js-infinite-scroll-sentinel');
  const productList = scrollContainer ? scrollContainer.querySelector('product-list') : document.querySelector('product-list');

  if (!scrollContainer || !sentinel || !productList) {
    // Restore default if not on collection page
    if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
    return;
  }

  // Inject top sentinel if we are on a page > 1 to allow loading previous items
  const urlParams = new URLSearchParams(window.location.search);
  const initialPage = parseInt(urlParams.get('page')) || 1;
  let topSentinel = document.getElementById('js-infinite-scroll-sentinel-top');
  
  if (initialPage > 1 && !topSentinel) {
    topSentinel = document.createElement('div');
    topSentinel.id = 'js-infinite-scroll-sentinel-top';
    topSentinel.className = 'infinite-scroll-sentinel infinite-scroll-sentinel--top';
    topSentinel.innerHTML = '<div class="js-loading-indicator loading-indicator hidden"><span class="loading-spinner"></span></div>';
    productList.parentNode.insertBefore(topSentinel, productList);
  }

  const isEnabled = scrollContainer.getAttribute('data-infinite-scroll-enabled') === 'true';
  if (!isEnabled) return;

  // Set to manual only for the collection page to stop jumps on refresh
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // Cleanup old handlers with consistent naming
  if (window.infiniteScrollHandler) {
    window.removeEventListener('scroll', window.infiniteScrollHandler);
    window.infiniteScrollHandler = null;
  }

  const pagination = document.querySelector('.pagination');
  if (pagination) pagination.style.display = 'none';

  let loading = false;
  let isReady = false; 
  let nextButton = document.querySelector('.js-pagination-next, [rel="next"]');
  let nextPageUrl = nextButton ? nextButton.href : null;
  let prevButton = document.querySelector('[rel="prev"]');
  let prevPageUrl = prevButton ? prevButton.href : null;

  function fetchPreviousPage() {
    if (loading || !prevPageUrl || !isReady) return;
    loading = true;

    const loader = topSentinel.querySelector('.js-loading-indicator');
    if (loader) loader.classList.remove('hidden');

    const section = scrollContainer.closest('.shopify-section');
    const sectionId = section ? section.id.replace('shopify-section-', '') : '';
    const url = new URL(prevPageUrl, window.location.origin);
    const prevPageNumber = url.searchParams.get('page') || '1';
    
    const fetchUrlParams = new URLSearchParams(window.location.search);
    fetchUrlParams.set('page', prevPageNumber);
    fetchUrlParams.set('section_id', sectionId);
    const fetchUrl = `${window.location.pathname}?${fetchUrlParams.toString()}`;

    // Store current scroll and height to adjust after prepend
    const previousScrollHeight = document.documentElement.scrollHeight;
    const previousScrollTop = window.scrollY;

    fetch(fetchUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newItems = doc.querySelectorAll('product-list > *');
        const nextPagination = doc.querySelector('.pagination');

        if (newItems.length > 0) {
          const fragment = document.createDocumentFragment();
          const cardsToReveal = [];

          newItems.forEach(item => {
            item.classList.remove('hidden');
            const card = item.matches('product-card') ? item : item.querySelector('product-card');
            if (card && card.getAttribute('reveal-on-scroll') === 'true') {
              cardsToReveal.push(card);
            }
            fragment.appendChild(item);
          });

          productList.insertBefore(fragment, productList.firstChild);

          // Update prevPageUrl from the new pagination
          if (nextPagination) {
            const freshPrev = nextPagination.querySelector('[rel="prev"]');
            prevPageUrl = freshPrev ? freshPrev.href : null;
          } else {
            prevPageUrl = null;
          }

          // Adjust scroll position to maintain view
          const newScrollHeight = document.documentElement.scrollHeight;
          window.scrollTo(0, previousScrollTop + (newScrollHeight - previousScrollHeight));

          if (cardsToReveal.length > 0 && typeof productList.reveal === 'function') {
            productList.reveal(cardsToReveal);
          }

          if (window.sizeWrapper) window.sizeWrapper();
          updateURLOnScroll();
        } else {
          prevPageUrl = null;
        }

        if (loader) loader.classList.add('hidden');
        loading = false;
        
        if (!prevPageUrl && topSentinel) {
          topSentinel.style.display = 'none';
        }
      })
      .catch(err => {
        console.error('[InfiniteScroll] Error fetching previous:', err);
        loading = false;
        if (loader) loader.classList.add('hidden');
      });
  }

  function fetchNextPage() {
    if (loading || !nextPageUrl || !isReady) return;
    loading = true;

    const loader = sentinel.querySelector('.js-loading-indicator');
    if (loader) loader.classList.remove('hidden');

    const section = scrollContainer.closest('.shopify-section');
    const sectionId = section ? section.id.replace('shopify-section-', '') : '';
    const url = new URL(nextPageUrl, window.location.origin);
    const nextPageNumber = url.searchParams.get('page') || '2';

    const fetchUrlParams = new URLSearchParams(window.location.search);
    fetchUrlParams.set('page', nextPageNumber);
    fetchUrlParams.set('section_id', sectionId);
    const fetchUrl = `${window.location.pathname}?${fetchUrlParams.toString()}`;

    fetch(fetchUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newItems = doc.querySelectorAll('product-list > *');
        const nextPagination = doc.querySelector('.pagination');

        if (newItems.length > 0) {
          const fragment = document.createDocumentFragment();
          const cardsToReveal = [];

          newItems.forEach(item => {
            item.classList.remove('hidden');
            const card = item.matches('product-card') ? item : item.querySelector('product-card');
            if (card && card.getAttribute('reveal-on-scroll') === 'true') {
              cardsToReveal.push(card);
            }
            fragment.appendChild(item);
          });

          productList.appendChild(fragment);

          const currentPaginationDOM = document.querySelector('.pagination');
          if (nextPagination && currentPaginationDOM) {
            currentPaginationDOM.innerHTML = nextPagination.innerHTML;
            const freshNext = currentPaginationDOM.querySelector('.js-pagination-next, [rel="next"]');
            nextPageUrl = freshNext ? freshNext.href : null;
          } else {
            nextPageUrl = null;
          }

          if (cardsToReveal.length > 0 && typeof productList.reveal === 'function') {
            productList.reveal(cardsToReveal);
          }

          if (window.sizeWrapper) window.sizeWrapper();
          updateURLOnScroll();
        } else {
          nextPageUrl = null;
        }

        if (loader) loader.classList.add('hidden');
        loading = false;
        
        if (!nextPageUrl) {
          sentinel.style.display = 'none';
          if (window.infiniteScrollHandler) window.removeEventListener('scroll', window.infiniteScrollHandler);
        }
      })
      .catch(err => {
        console.error('[InfiniteScroll] Error:', err);
        loading = false;
        if (loader) loader.classList.add('hidden');
      });
  }

  function updateURLOnScroll() {
    const markers = productList.querySelectorAll('[data-page]');
    const url = new URL(window.location.href);
    const currentPage = url.searchParams.get('page') || "1";
    let activePage = "1";

    markers.forEach(marker => {
      const rect = marker.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.8) {
        activePage = marker.getAttribute('data-page');
      }
    });

    if (currentPage !== activePage) {
      if (activePage === "1") url.searchParams.delete('page');
      else url.searchParams.set('page', activePage);
      window.history.replaceState({ page: activePage }, '', url.pathname + url.search);
    }
  }

  function checkScroll() {
    if (loading || !isReady) return;

    // Check bottom sentinel for Next Page
    if (nextPageUrl) {
      const sentinelRect = sentinel.getBoundingClientRect();
      if (sentinelRect.top < window.innerHeight + 1800) {
        fetchNextPage();
      }
    }

    // Check top sentinel for Previous Page
    if (prevPageUrl && topSentinel) {
      const topSentinelRect = topSentinel.getBoundingClientRect();
      if (topSentinelRect.bottom > -1000) { // Trigger when near the top
        fetchPreviousPage();
      }
    }

    updateURLOnScroll();
  }

  let scrollTimeout;
  window.infiniteScrollHandler = () => {
    if (scrollTimeout) return;
    scrollTimeout = setTimeout(() => {
      checkScroll();
      scrollTimeout = null;
    }, 100);
  };

  window.addEventListener('scroll', window.infiniteScrollHandler);
  
  setTimeout(() => {
    isReady = true;
    checkScroll();
  }, 500);
}

document.addEventListener('DOMContentLoaded', initInfiniteScroll);
document.addEventListener('shopify:section:load', initInfiniteScroll);
document.addEventListener('facets:loaded', () => { 
  setTimeout(initInfiniteScroll, 200); 
});

/**
 * Facets drawer clear button
 */
let keepFacetsDrawerOpenAfterUpdate = false;

function formHasActiveSelections(form) {
  if (form.querySelector('input[name*="filter."]:checked')) {
    return true;
  }

  const priceGte = form.querySelector('input[name="filter.v.price.gte"]');
  const priceLte = form.querySelector('input[name="filter.v.price.lte"]');

  return Boolean(priceGte?.value || priceLte?.value);
}

function updateClearButtonState(clearButton, form) {
  const hasFilters = formHasActiveSelections(form);
  const footer = clearButton.closest('.facets-drawer-footer');

  clearButton.hidden = !hasFilters;
  footer?.classList.toggle('facets-drawer-footer--apply-only', !hasFilters);
}

function resetFacetsForm(form) {
  form.querySelectorAll('input[name*="filter."]:checked').forEach((input) => {
    input.checked = false;
  });

  form.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach((input) => {
    input.value = '';
  });
}

function normalizeFacetsDrawerFooter(root = document) {
  root.querySelectorAll('facets-drawer .facets-drawer-footer').forEach((footer) => {
    const nativeClear = footer.querySelector('[data-facets-clear-button]');
    const applyButton = footer.querySelector('[data-facets-apply-button]');

    footer.querySelectorAll('.ym-vwo-footer-clear').forEach((button) => {
      if (button !== nativeClear) {
        button.remove();
      }
    });

    footer.querySelectorAll('.ym-vwo-footer-apply').forEach((button) => {
      if (button !== applyButton) {
        button.remove();
      }
    });

    if (!applyButton) {
      return;
    }

    applyButton.hidden = false;
    applyButton.removeAttribute('aria-hidden');
    applyButton.classList.remove('ym-vwo-native-apply-hidden');

    const applyLabel = applyButton.dataset.applyLabel || 'Aplicar';
    const currentLabel = applyButton.textContent.trim().toLowerCase();

    if (currentLabel.includes('quitar') || currentLabel.includes('remove') || currentLabel.includes('borrar')) {
      applyButton.textContent = applyLabel;
    }

    if (nativeClear) {
      const form = footer.closest('facets-drawer')?.querySelector('[is="facets-form"]');
      if (form) {
        updateClearButtonState(nativeClear, form);
      }
    }
  });
}

function cleanupOrphanedFacetsDrawers() {
  document.querySelectorAll('body > facets-drawer').forEach((drawer) => {
    drawer.remove();
  });
}

function restoreFacetsDrawerIfNeeded() {
  if (!keepFacetsDrawerOpenAfterUpdate) {
    return;
  }

  keepFacetsDrawerOpenAfterUpdate = false;
  cleanupOrphanedFacetsDrawers();

  const drawer = document.getElementById('facets-drawer');
  drawer?.show(false);
}

function initFacetsDrawerClearButtons(root = document) {
  normalizeFacetsDrawerFooter(root);

  root.querySelectorAll('facets-drawer').forEach((drawer) => {
    if (drawer.dataset.footerOpenHandler !== 'true') {
      drawer.dataset.footerOpenHandler = 'true';
      drawer.addEventListener('dialog:after-show', () => {
        normalizeFacetsDrawerFooter(drawer);
      });
    }

    const clearButton = drawer.querySelector('[data-facets-clear-button]');
    const form = drawer.querySelector('[is="facets-form"]');

    if (!clearButton || !form || clearButton.dataset.initialized === 'true') {
      return;
    }

    clearButton.dataset.initialized = 'true';

    updateClearButtonState(clearButton, form);

    form.addEventListener('change', () => {
      updateClearButtonState(clearButton, form);
    });

    form.addEventListener('input', () => {
      updateClearButtonState(clearButton, form);
    });

    clearButton.addEventListener('click', (event) => {
      if (clearButton.hidden) {
        return;
      }

      event.preventDefault();
      keepFacetsDrawerOpenAfterUpdate = drawer.open;
      resetFacetsForm(form);
      updateClearButtonState(clearButton, form);
      form.dispatchEvent(new Event('change', { bubbles: true }));

      if (HTMLFormElement.prototype.requestSubmit) {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initFacetsDrawerClearButtons());
document.addEventListener('facets:loaded', () => {
  initFacetsDrawerClearButtons();
  restoreFacetsDrawerIfNeeded();
});

/**
 * Filter drawer: only one accordion open at a time
 */
function closeFacetsAccordion(details) {
  if (typeof details.toggle === 'function') {
    details.toggle(false);
    return;
  }

  details.removeAttribute('open');
  details.setAttribute('aria-expanded', 'false');
}

function isFacetsAccordionOpen(details) {
  return details.open || details.getAttribute('aria-expanded') === 'true';
}

function enforceSingleOpenFacetsAccordion(drawer) {
  if (!drawer.hasAttribute('data-single-accordion')) {
    return;
  }

  const openDetails = [...drawer.querySelectorAll('[is="facets-form"] details')].filter(isFacetsAccordionOpen);

  if (openDetails.length <= 1) {
    return;
  }

  openDetails.slice(1).forEach(closeFacetsAccordion);
}

function initFacetsDrawerSingleAccordion() {
  if (window.facetsDrawerSingleAccordionInit) {
    return;
  }

  window.facetsDrawerSingleAccordionInit = true;

  document.addEventListener('toggle', (event) => {
    const details = event.target;

    if (!(details instanceof HTMLDetailsElement)) {
      return;
    }

    const drawer = details.closest('facets-drawer[data-single-accordion]');

    if (!drawer || !details.closest('[is="facets-form"]') || !details.open) {
      return;
    }

    drawer.querySelectorAll('[is="facets-form"] details').forEach((other) => {
      if (other !== details && isFacetsAccordionOpen(other)) {
        closeFacetsAccordion(other);
      }
    });
  }, true);
}

function initFacetsDrawerSingleAccordionHandlers(root = document) {
  initFacetsDrawerSingleAccordion();

  root.querySelectorAll('facets-drawer[data-single-accordion]').forEach((drawer) => {
    if (drawer.dataset.singleAccordionHandler === 'true') {
      return;
    }

    drawer.dataset.singleAccordionHandler = 'true';

    drawer.addEventListener('dialog:after-show', () => {
      enforceSingleOpenFacetsAccordion(drawer);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initFacetsDrawerSingleAccordionHandlers());
document.addEventListener('facets:loaded', () => initFacetsDrawerSingleAccordionHandlers());

/**
 * Bra size filter: Cup <-> Contour UI narrowing + hidden talla-sujetador combo checkboxes.
 * When both Cup and Contour are selected, matching hidden combo inputs are checked for form submit.
 */
const braSizeSelectors = {
  group: '.js-bra-size-group',
  config: '.js-bra-size-config',
  cupOption: '.js-bra-cup-option',
  contourOption: '.js-bra-contour-option',
  comboInput: '.js-bra-combo-input'
};

function getCupContourMap(container) {
  const script = container.querySelector(braSizeSelectors.config);

  if (!script) {
    return null;
  }

  try {
    const map = JSON.parse(script.textContent);
    return map && typeof map === 'object' ? map : null;
  } catch (error) {
    return null;
  }
}

function getCheckedOptionValues(container, selector) {
  return Array.from(container.querySelectorAll(`${selector} input:checked`), (input) => input.value.toUpperCase());
}

function getAllowedContoursForCups(map, cupLetters) {
  const allowed = new Set();

  cupLetters.forEach((cupLetter) => {
    (map[cupLetter] || []).forEach((contourValue) => allowed.add(contourValue));
  });

  return allowed;
}

function getAllowedCupsForContours(map, contourValues) {
  const allowed = new Set();

  Object.keys(map).forEach((cupLetter) => {
    const supportsSelection = (map[cupLetter] || []).some((contourValue) => contourValues.includes(contourValue));

    if (supportsSelection) {
      allowed.add(cupLetter);
    }
  });

  return allowed;
}

function applyCupContourDependency(container) {
  const map = getCupContourMap(container);

  if (!map) {
    return;
  }

  const activeCups = getCheckedOptionValues(container, braSizeSelectors.cupOption);
  const activeContours = getCheckedOptionValues(container, braSizeSelectors.contourOption);

  const allowedContours = activeCups.length ? getAllowedContoursForCups(map, activeCups) : null;
  const allowedCups = activeContours.length ? getAllowedCupsForContours(map, activeContours) : null;

  container.querySelectorAll(braSizeSelectors.contourOption).forEach((option) => {
    const isAllowed = !allowedContours || allowedContours.has(option.dataset.contourOption);

    option.hidden = !isAllowed;

    if (!isAllowed) {
      const input = option.querySelector('input');
      if (input && input.checked) {
        input.checked = false;
      }
    }
  });

  container.querySelectorAll(braSizeSelectors.cupOption).forEach((option) => {
    const isAllowed = !allowedCups || allowedCups.has(option.dataset.cupOption);

    option.hidden = !isAllowed;

    if (!isAllowed) {
      const input = option.querySelector('input');
      if (input && input.checked) {
        input.checked = false;
      }
    }
  });
}

function parseBraCombo(combo) {
  const normalized = (combo || '').trim().toUpperCase();

  if (!normalized || normalized.length < 2) {
    return null;
  }

  return {
    cup: normalized.slice(-1),
    contour: normalized.slice(0, -1)
  };
}

function syncVisibleSelectionsFromUrl(container) {
  const hiddenWrap = container.querySelector('.js-bra-hidden-combos');
  const paramName = hiddenWrap?.dataset.paramName;

  if (!paramName) {
    return;
  }

  const combos = new URL(window.location.href).searchParams.getAll(paramName);

  if (!combos.length) {
    return;
  }

  const cups = new Set();
  const contours = new Set();

  combos.forEach((combo) => {
    const parsed = parseBraCombo(combo);

    if (!parsed) {
      return;
    }

    cups.add(parsed.cup);
    contours.add(parsed.contour);
  });

  container.querySelectorAll(braSizeSelectors.cupOption).forEach((option) => {
    const input = option.querySelector('input');
    const cup = (option.dataset.cupOption || input?.value || '').trim().toUpperCase();

    if (input) {
      input.checked = cups.has(cup);
    }
  });

  container.querySelectorAll(braSizeSelectors.contourOption).forEach((option) => {
    const input = option.querySelector('input');
    const contour = (option.dataset.contourOption || input?.value || '').trim();

    if (input) {
      input.checked = contours.has(contour);
    }
  });
}

function getCheckedBraFilterValues(container, selector, uppercase = false) {
  return Array.from(container.querySelectorAll(`${selector} input:checked`), (input) => {
    const value = (input.value || '').trim();
    return uppercase ? value.toUpperCase() : value;
  }).filter(Boolean);
}

function syncHiddenBraCombos(container) {
  const cups = getCheckedBraFilterValues(container, braSizeSelectors.cupOption, true);
  const contours = getCheckedBraFilterValues(container, braSizeSelectors.contourOption, false);
  const useComboFilter = cups.length > 0 && contours.length > 0;
  const combos = new Set();

  if (useComboFilter) {
    contours.forEach((contour) => {
      cups.forEach((cup) => {
        combos.add(`${contour}${cup}`.toUpperCase());
      });
    });
  }

  const hiddenWrap = container.querySelector('.js-bra-hidden-combos');
  const comboInputs = hiddenWrap ? [...hiddenWrap.querySelectorAll(braSizeSelectors.comboInput)] : [];
  const paramName = hiddenWrap?.dataset.paramName || comboInputs[0]?.name;

  hiddenWrap?.querySelectorAll('.js-bra-combo-input--dynamic').forEach((input) => input.remove());

  comboInputs.forEach((input) => {
    const combo = (input.dataset.combo || input.value || '').trim().toUpperCase();
    input.checked = useComboFilter && combos.has(combo);
  });

  if (useComboFilter && hiddenWrap && paramName) {
    combos.forEach((combo) => {
      const exists = comboInputs.some((input) => {
        const value = (input.dataset.combo || input.value || '').trim().toUpperCase();
        return value === combo;
      });

      if (!exists) {
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'js-bra-combo-input js-bra-combo-input--dynamic';
        input.name = paramName;
        input.value = combo;
        input.dataset.combo = combo;
        input.checked = true;
        hiddenWrap.appendChild(input);
      }
    });
  }

  container.querySelectorAll(`${braSizeSelectors.cupOption} input, ${braSizeSelectors.contourOption} input`).forEach((input) => {
    if (useComboFilter) {
      if (!input.dataset.originalName) {
        input.dataset.originalName = input.name;
      }

      input.removeAttribute('name');
      return;
    }

    if (input.dataset.originalName) {
      input.name = input.dataset.originalName;
    }
  });
}

function initBraSizeFilters(root = document) {
  root.querySelectorAll(braSizeSelectors.group).forEach((container) => {
    syncVisibleSelectionsFromUrl(container);
    applyCupContourDependency(container);
    syncHiddenBraCombos(container);
  });
}

document.addEventListener('change', (event) => {
  const option = event.target.closest(`${braSizeSelectors.cupOption}, ${braSizeSelectors.contourOption}`);

  if (!option) {
    return;
  }

  const container = option.closest(braSizeSelectors.group);

  if (container) {
    applyCupContourDependency(container);
    syncHiddenBraCombos(container);
  }
}, true);

function syncHiddenBraCombosInForm(form) {
  form?.querySelectorAll(braSizeSelectors.group).forEach((container) => {
    syncHiddenBraCombos(container);
  });
}

document.addEventListener('submit', (event) => {
  const form = event.target.matches?.('[is="facets-form"]') ? event.target : event.target.closest?.('[is="facets-form"]');
  syncHiddenBraCombosInForm(form);
}, true);

document.addEventListener('click', (event) => {
  const applyButton = event.target.closest('[data-facets-apply-button]');

  if (!applyButton) {
    return;
  }

  const form = applyButton.closest('facets-drawer')?.querySelector('[is="facets-form"]');
  syncHiddenBraCombosInForm(form);
}, true);

const TALLA_SUJETADOR_PARAM_PATTERN = /talla_sujetador$/;

function countActiveFiltersFromUrl() {
  const url = new URL(window.location.href);
  let count = 0;

  if (url.searchParams.get('filter.v.price.gte') || url.searchParams.get('filter.v.price.lte')) {
    count += 1;
  }

  const seenParams = new Set();

  url.searchParams.forEach((_value, key) => {
    if (!key.startsWith('filter.')) {
      return;
    }

    if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
      return;
    }

    if (seenParams.has(key)) {
      return;
    }

    seenParams.add(key);

    const values = url.searchParams.getAll(key).filter((value) => value && value !== '-');

    if (TALLA_SUJETADOR_PARAM_PATTERN.test(key)) {
      count += values.length * 2;
      return;
    }

    count += values.length;
  });

  return count;
}

function syncFilterButtonCount(root = document) {
  const count = countActiveFiltersFromUrl();

  root.querySelectorAll('.js-filter-count-button').forEach((button) => {
    const label = button.dataset.filterLabel || button.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();

    if (!button.dataset.filterLabel) {
      button.dataset.filterLabel = label;
    }

    button.textContent = count > 0 ? `${label} (${count})` : label;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initBraSizeFilters();
  syncFilterButtonCount();
});

document.addEventListener('facets:loaded', () => {
  initBraSizeFilters();
  syncFilterButtonCount();
});

document.addEventListener('dialog:after-show', (event) => {
  if (event.target?.matches?.('facets-drawer')) {
    initBraSizeFilters(event.target);
  }
});

